"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownTitle = void 0;
const theme_1 = require("@pulse-web-ui/theme");
require("react");
exports.DropdownTitle = theme_1.styled.div `
  ${theme_1.typography.subhead2.regular}
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: 4px;
  white-space: break-spaces;
  word-break: break-word;
  text-align: center;
`;
